module.exports = __webpack_public_path__ + "img/teppich3.0c0f48aa.png";